import React, { useMemo } from 'react';
import { processingResultList } from 'utils/dataArray';
import tramitacion from 'img/fake/tramitacion.svg';
import linkIco from 'img/content/ico_link.svg';

export default function ShareTab(props) {
  const { lawData, relatedInfo, legislatureSlug } = props;
  const RESULTS_DEFAULT = 'En tramitación';
  const ICON_DEFAULT = tramitacion;
  const index = processingResultList.findIndex(el => el.name === lawData?.processingResult);
  const img = processingResultList[index]?.src || ICON_DEFAULT;
  const text = processingResultList[index]?.name || RESULTS_DEFAULT;
  const linkPath = lawData?.slug != null && lawData?.slug != undefined ? lawData.slug : 'mocked';
  const currentLink = window._env_.REACT_APP_HOMEPAGE + '/' + legislatureSlug + '/embed/' + linkPath;

  const copyLink = link => {
    navigator.clipboard.writeText(link);
  };

  const relatedSrc = useMemo(() => {
    return relatedInfo?.map(info => {
      return info?.file ? URL.createObjectURL(info?.file) : info?.image;
    });
  }, [relatedInfo]);

  const shareOptions = [
    {
      title: 'Link',
      svg: linkIco,
      url: `<iframe src='${currentLink}' height='667' width='375' allowFullScreen='false' ></iframe>`,
    },
    {
      title: 'Twitter',
      svg: (
        <svg width='16' height='13' viewBox='0 0 16 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M15.3332 0.999868C14.6948 1.45019 13.9879 1.79461 13.2398 2.01987C12.8383 1.55821 12.3047 1.231 11.7112 1.08249C11.1177 0.933975 10.4928 0.971332 9.92122 1.1895C9.34961 1.40768 8.8588 1.79614 8.51516 2.30235C8.17152 2.80856 7.99164 3.40809 7.99984 4.01987V4.68653C6.82826 4.71691 5.66735 4.45708 4.62051 3.93017C3.57367 3.40325 2.67338 2.62562 1.99984 1.66653C1.99984 1.66653 -0.666829 7.66653 5.33317 10.3332C3.96019 11.2652 2.32461 11.7325 0.666504 11.6665C6.6665 14.9999 13.9998 11.6665 13.9998 3.99987C13.9992 3.81417 13.9814 3.62893 13.9465 3.44653C14.6269 2.77553 15.1071 1.92834 15.3332 0.999868Z'
            fill='black'
          />
        </svg>
      ),
      url: `https://twitter.com/intent/tweet?url=${currentLink}&hasthags`,
    },
    {
      title: 'Facebook',
      svg: (
        <svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M7.99996 0.333252H5.99996C5.1159 0.333252 4.26806 0.684441 3.64294 1.30956C3.01782 1.93468 2.66663 2.78253 2.66663 3.66659V5.66659H0.666626V8.33325H2.66663V13.6666H5.33329V8.33325H7.33329L7.99996 5.66659H5.33329V3.66659C5.33329 3.48977 5.40353 3.32021 5.52855 3.19518C5.65358 3.07016 5.82315 2.99992 5.99996 2.99992H7.99996V0.333252Z'
            fill='black'
          />
        </svg>
      ),
      url: `https://www.facebook.com/sharer/sharer?u=${currentLink}`,
    },
    {
      title: 'Whatsapp',
      svg: (
        <svg width='16' height='16' viewBox='-23 -21 682 682.66669' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='m544.386719 93.007812c-59.875-59.945312-139.503907-92.9726558-224.335938-93.007812-174.804687 0-317.070312 142.261719-317.140625 317.113281-.023437 55.894531 14.578125 110.457031 42.332032 158.550781l-44.992188 164.335938 168.121094-44.101562c46.324218 25.269531 98.476562 38.585937 151.550781 38.601562h.132813c174.785156 0 317.066406-142.273438 317.132812-317.132812.035156-84.742188-32.921875-164.417969-92.800781-224.359376zm-224.335938 487.933594h-.109375c-47.296875-.019531-93.683594-12.730468-134.160156-36.742187l-9.621094-5.714844-99.765625 26.171875 26.628907-97.269531-6.269532-9.972657c-26.386718-41.96875-40.320312-90.476562-40.296875-140.28125.054688-145.332031 118.304688-263.570312 263.699219-263.570312 70.40625.023438 136.589844 27.476562 186.355469 77.300781s77.15625 116.050781 77.132812 186.484375c-.0625 145.34375-118.304687 263.59375-263.59375 263.59375zm144.585938-197.417968c-7.921875-3.96875-46.882813-23.132813-54.148438-25.78125-7.257812-2.644532-12.546875-3.960938-17.824219 3.96875-5.285156 7.929687-20.46875 25.78125-25.09375 31.066406-4.625 5.289062-9.242187 5.953125-17.167968 1.984375-7.925782-3.964844-33.457032-12.335938-63.726563-39.332031-23.554687-21.011719-39.457031-46.960938-44.082031-54.890626-4.617188-7.9375-.039062-11.8125 3.476562-16.171874 8.578126-10.652344 17.167969-21.820313 19.808594-27.105469 2.644532-5.289063 1.320313-9.917969-.664062-13.882813-1.976563-3.964844-17.824219-42.96875-24.425782-58.839844-6.4375-15.445312-12.964843-13.359374-17.832031-13.601562-4.617187-.230469-9.902343-.277344-15.1875-.277344-5.28125 0-13.867187 1.980469-21.132812 9.917969-7.261719 7.933594-27.730469 27.101563-27.730469 66.105469s28.394531 76.683594 32.355469 81.972656c3.960937 5.289062 55.878906 85.328125 135.367187 119.648438 18.90625 8.171874 33.664063 13.042968 45.175782 16.695312 18.984374 6.03125 36.253906 5.179688 49.910156 3.140625 15.226562-2.277344 46.878906-19.171875 53.488281-37.679687 6.601563-18.511719 6.601563-34.375 4.617187-37.683594-1.976562-3.304688-7.261718-5.285156-15.183593-9.253906zm0 0'
            fill='black'
          />
        </svg>
      ),
      url: `https://wa.me/?text=${currentLink}`,
    },
    {
      title: 'Meneame',
      svg: (
        <svg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000' width='16' height='16'>
          <path
            fill='black'
            d='M507.9,471.6c-20.8,12.9-41.6,20.2-63.5,24.8c-32.1,6.8-64.4,6.8-96.5,0.6c-27.7-5.3-50.5-20.3-68.8-41.1c-36.4-41.3-62.6-88.1-70.4-143.5c-10.6-75.9,16-137.4,74.2-185.7c41.8-34.6,91.4-51.4,144.1-60.8c82.7-14.7,160.9,1.4,236.6,34.2c38.8,16.8,76.4,36.7,116.5,50.6c8.9,3.1,17.8,5.8,27.1,7.2c16.8,2.4,30.6-3.3,41.7-15.8c14.5-16.4,19.6-36,19.5-57.4c4.1-0.2,4.9,2.9,6.2,5.3c12.4,22.7,8.8,59.6-7.9,78.8c-17.5,20.1-40.8,23.7-65.6,20.8c-28.2-3.3-54.9-11.5-80.6-23.7c-48.2-23-97.2-44.2-149.6-56.1c-65.6-14.9-130.7-12.2-194.4,8.9c-92.7,30.8-141.5,122.9-116.2,217.5c14.6,54.6,45.3,97.6,93.2,127.9c20.7,13.2,43.6,17.3,67.7,17c24.4-0.3,48.2-5.1,72-9.6C497.5,470.7,501.5,469.7,507.9,471.6z'
          />
          <path
            d='M605.5,936.8c-4.5-1.5-12.8,3.5-14.1-2.7c-1.3-6.1,7.4-8.1,12.4-10.2c30.8-12.8,61.8-25,92.5-37.8c19.1-8,37.8-16.9,55-28.7c5.9-4,11.3-8.6,16.1-14c7.6-8.5,9.4-17.4,5-28.6c-23.4-58.6-49.5-116.1-70-175.9c-16.5-48.2-29.6-97-33.1-148.3c-4.1-60.4,16.8-107.5,69-139.8c24.6-15.3,51-26.7,77.4-38.1c32.7-14.1,65-28.6,93.7-50.5c42.9-32.7,57-76.6,53.3-128.4c-1.7-23.3-5.5-46.2-10.9-68.9c-0.6-2.6-4.1-6.4,0.5-8.4c4.2-1.8,6.4,1.4,8.2,4.7c14,25.4,24.9,51.7,28.3,80.9c6.6,56.1-18,98.9-56.8,136c-24.8,23.6-55.2,38.2-85.2,53.5c-27.1,13.8-55.1,26-80.6,42.7c-27.8,18.2-50.9,40.4-58.6,74.3c-6.2,27.6-1.2,54.9,4.4,81.9c12.2,59.4,36.3,114.7,60,170c12.3,28.5,25.4,56.8,35.1,86.3c15.8,47.6,2.6,84.3-39.8,111c-30.5,19.2-64.6,27.6-99.6,33.2C647.4,934.4,626.7,935.5,605.5,936.8z'
            fill='black'
          />
          <path
            fill='black'
            d='M195.5,366c-0.8,5-3.6,8.7-6.3,12.5C144,443.2,105.2,511.3,75.9,584.8c-20.4,51.2-25.3,103.5-11.8,157c16.7,66.2,60.7,107,122.8,131c45,17.4,92,25.8,139.6,31.4c66.2,7.8,132.6,13.1,199,19.5c6.4,0.6,12.7,2.4,18.9,4c3,0.8,6.9,2,6.5,6.1c-0.5,4.7-4.9,3.3-7.8,3.5c-42.9,3.5-85.9,5.4-129,6.1c-60.6,0.9-121.4,1.3-181.2-8.7C135.7,918.3,60.5,870,23.9,774.5C4.3,723.4,6.8,670,22.6,618c23.7-78,59.5-149.6,117.7-208.2c15.1-15.2,32.1-28.2,48.7-41.6C190.7,367,192.2,364.9,195.5,366z'
          />
          <path
            fill='black'
            d='M361.2,721c68.7-11.3,137.2-17.4,206.3-9.2c32.9,4,39.2,10.7,39.9,43.9c1.2,52.5-6.1,104-21,154.4c-2.5,8.4-5.6,16.6-10.8,23.8c-2.1,2.8-4.3,6.4-8.6,4.9c-3.7-1.3-3.2-5.2-3.4-8.4c-1-22.4,2.7-44.6,4.7-66.8c3-31.9,8.3-63.6,5.4-95.8c-0.9-10.2-5.6-16.4-14.7-20.8c-26.8-12.8-55.5-17-84.5-19.9c-35.5-3.4-71.2-3.1-106.7-5.2C365.6,721.8,363.5,721.3,361.2,721z'
          />
        </svg>
      ),
      url: `http://meneame.net/login.php?return=/submit.php?url=${currentLink}`,
    },
  ];

  return (
    <div className='sharetab'>
      <div className='sharetab__container'>
        <div className='sharetab__info'>
          <div className='sharetab__pretitle'>
            <i className='sharetab__pretitle--ico'>
              <img src={img} alt={text} />
            </i>
            <p className='sharetab__pretitle--text'>{text}</p>
          </div>
          <div className='sharetab__title'>
            <h1>{lawData?.titleAlias}</h1>
          </div>
          <div className='sharetab__summary'>{lawData?.title}</div>
          <div className='sharetab__parlamentia'>www.parlamentia.es</div>
        </div>
        <div className='sharetab__links'>
          {shareOptions?.map((opt, i) =>
            opt?.title !== 'Link' ? (
              <a className={`sharetab__links--${opt?.title.toLowerCase()}`} href={opt?.url} target='_blank' rel='noreferrer' key={i}>
                <i>{opt?.svg}</i>
                <span>{opt?.title}</span>
              </a>
            ) : (
              <a className='sharetab__links--code' onClick={() => copyLink(opt?.url)} key={i}>
                <img src={opt?.svg} />
                <span>{opt?.title}</span>
              </a>
            ),
          )}
        </div>
      </div>
      {relatedInfo && (
        <div className='sharetab__related'>
          <h2>Contenido relacionado</h2>
          <ul className='sharetab__list'>
            {relatedInfo?.map((item, i) => (
              <li className='sharetab__child' key={i}>
                <div className='sharetab__child--info'>
                  <a href={item?.url}>{item?.title}</a>
                  <p>{item?.host}</p>
                </div>
                <img src={relatedSrc[i]} />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
